/**
 * TUT-472 — a quantidade com a palavra flexionada: "1 versão", "2 versões".
 *
 * O QA achou "1 versão(ões)" nos documentos e "Notificações: 1 não lidas" no
 * sino: texto fixo no plural, escrito sem pensar no 1. Em português o zero vai
 * no plural ("0 versões"), então só o 1 pede o singular.
 */
export function contagem(quantidade: number, uma: string, varias: string): string {
  return `${quantidade} ${quantidade === 1 ? uma : varias}`;
}
